import React from 'react'

import { Flex, Text } from '@driftt/dds'

import { ActivityEndUser, ScoredActivity } from 'modules/accountActivity/domain'
import { PrimaryRouterLink } from 'pages/ActivityDashboard'

import { contactPath } from './paths'

export const getEndUserDisplayName = (endUser: ActivityEndUser | ScoredActivity) =>
  endUser.name || endUser.email || 'Site Visitor'

export const EndUserDisplayInfo = ({
  endUserData,
  orientation = 'horizontal',
  trackContactClick
}: {
  endUserData: ActivityEndUser
  orientation: 'horizontal' | 'vertical'
  trackContactClick?: () => void
}) => {
  const endUserDisplayName = getEndUserDisplayName(endUserData)

  return (
    <Flex
      direction={orientation === 'vertical' ? 'column' : 'row'}
      gap={0}
      css={{ maxWidth: '200px' }}>
      <PrimaryRouterLink
        onClick={() => trackContactClick && trackContactClick()}
        to={contactPath(endUserData.id)}
        css={{ fontSize: '12px' }}>
        {endUserDisplayName}
      </PrimaryRouterLink>
      {endUserData.role ? (
        <Text variant="metadata">{endUserData.role}</Text>
      ) : (
        <Text variant="metadata" truncate>
          {getEndUserDisplayLocation(
            endUserData.locationCity,
            endUserData.locationStateCode ?? endUserData.locationState,
            endUserData.locationCountryCode ?? endUserData.locationCountry
          )}
        </Text>
      )}
    </Flex>
  )
}

export const getDisplayStringWithFallback = (string?: string) => string ?? '-'

export const getEndUserDisplayLocation = (city: string, stateCode: string, countryCode: string) => {
  if (countryCode === 'US') {
    return `${city ?? ''}${stateCode ? ', ' : ''}${stateCode ?? ''}`
  } else if (city && countryCode) {
    return `${city ?? ''}${countryCode ? ', ' : ''}${countryCode ?? ''}`
  }
  return '-'
}
